/**
 * Lightweight namespaced logger. Production builds suppress debug output.
 */
const isDev = import.meta.env?.DEV ?? false;

type Level = 'debug' | 'info' | 'warn' | 'error';

function emit(level: Level, scope: string, args: unknown[]): void {
  const ts = new Date().toISOString();
  const prefix = `[${ts}] [${level.toUpperCase()}] [${scope}]`;
  const consoleFn = level === 'debug' ? 'log' : level;
  if (level === 'debug' && !isDev) return;
  // eslint-disable-next-line no-console
  (console[consoleFn] as (...a: unknown[]) => void)(prefix, ...args);
}

export function createLogger(scope: string) {
  return {
    debug: (...args: unknown[]) => emit('debug', scope, args),
    info: (...args: unknown[]) => emit('info', scope, args),
    warn: (...args: unknown[]) => emit('warn', scope, args),
    error: (...args: unknown[]) => emit('error', scope, args),
  };
}
